import React, { useRef, Children } from 'react';
import { motion, useInView } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
export function AudienceSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const audiences = ['Madres que trabajan desde casa y sienten que el rol las sobrepasa.', 'Emprendedoras que aman lo que hacen pero odian la sensación de "no estar nunca al 100%".', 'Mujeres que quieren recuperar su identidad profesional sin descuidar la crianza.'];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: 'easeOut'
      }
    }
  };
  return <section ref={ref} className="w-full bg-[#F3EDF7] py-20 md:py-28" data-id="element-1">
      <div className="max-w-4xl mx-auto px-6" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} className="text-center mb-12" data-id="element-3">
          <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl lg:text-5xl font-bold text-[#2D2D2D]" data-id="element-4">
            ¿Para quién es esto?
          </h2>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" animate={isInView ? 'visible' : 'hidden'} className="bg-white rounded-3xl p-8 md:p-12 shadow-lg" data-id="element-5">
          <div className="space-y-6" data-id="element-6">
            {audiences.map((audience, index) => <motion.div key={index} variants={itemVariants} className="flex items-start gap-4" data-id="element-7">
                <CheckCircleIcon className="w-7 h-7 text-[#E07A5F] flex-shrink-0 mt-0.5" data-id="element-8" />
                <p className="text-lg md:text-xl text-[#2D2D2D] leading-relaxed" data-id="element-9">
                  {audience}
                </p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}